import { cn } from "../lib/utils";

export function PriorityBadge({ priority, className, ...props }) {
  const styles = {
    alta: "bg-red-50 text-red-700 border-red-200",
    media: "bg-amber-50 text-amber-700 border-amber-200",
    bassa: "bg-slate-100 text-slate-700 border-slate-200",
  };
  const labels = { alta: "Alta", media: "Media", bassa: "Bassa" };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border",
        styles[priority] || styles.media,
        className
      )}
      {...props}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", priority === "alta" ? "bg-red-500" : priority === "media" ? "bg-amber-500" : "bg-slate-400")} />
      {labels[priority] || priority}
    </span>
  );
}

export function StatusBadge({ status, className, ...props }) {
  const map = {
    da_fare: { label: "Da fare", cls: "bg-red-50 text-red-700 border-red-200" },
    in_corso: { label: "In corso", cls: "bg-amber-50 text-amber-700 border-amber-200" },
    in_attesa: { label: "In attesa", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    completata: { label: "Completata", cls: "bg-green-50 text-green-700 border-green-200" },
    sospesa: { label: "Sospesa", cls: "bg-slate-100 text-slate-700 border-slate-200" },
    emessa: { label: "Emessa", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    pagata: { label: "Pagata", cls: "bg-green-50 text-green-700 border-green-200" },
    annullata: { label: "Annullata", cls: "bg-slate-100 text-slate-600 border-slate-200" },
    sollecitata: { label: "Sollecitata", cls: "bg-red-50 text-red-700 border-red-200" },
    bozza: { label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-200" },
    inviato: { label: "Inviato", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    accettato: { label: "Accettato", cls: "bg-green-50 text-green-700 border-green-200" },
    rifiutato: { label: "Rifiutato", cls: "bg-red-50 text-red-700 border-red-200" },
  };
  const s = map[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border", s.cls, className)} {...props}>
      {s.label}
    </span>
  );
}
